/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Drag_HandleInputs */



/**
* | output |
* | --- |
* | "Drag to reorder" |
*
* @param {Transcript_Export_Drag_HandleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_drag_handle = /** @type {((inputs?: Transcript_Export_Drag_HandleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Drag_HandleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Drag to reorder")
	if (locale === "de") return /** @type {LocalizedString} */ ("Drag to reorder")
	if (locale === "it") return /** @type {LocalizedString} */ ("Drag to reorder")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Drag to reorder")
	if (locale === "es") return /** @type {LocalizedString} */ ("Drag to reorder")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Drag to reorder")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Drag to reorder")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Drag to reorder")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Drag to reorder")
	return /** @type {LocalizedString} */ ("Drag to reorder")
});